/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BillingDocument } from '../../models/billing-document';
import { BillingDocumentComplete } from '../../models/billing-document-complete';

export interface CompleteBillingDocument$Params {
  id: number;
      body: BillingDocumentComplete
}

export function completeBillingDocument(http: HttpClient, rootUrl: string, params: CompleteBillingDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<BillingDocument>> {
  const rb = new RequestBuilder(rootUrl, completeBillingDocument.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BillingDocument>;
    })
  );
}

completeBillingDocument.PATH = '/billing-document/{id}';
